import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useContext } from "react";
import { AppContext } from "../../AppContext";
import LogoImg from "../../assets/Logo_50x50.jpg";
import LogInButton from "../Auth/LogInButton";
import Centered from "./Centered";
import { Link } from "./Link";
import Spacer from "./Spacer";
import { cssVar } from "./colors";

const StyledNavbar = styled.div(
  () => css`
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1em;
    height: ${cssVar("navbar-height")};
    z-index: 1;
    box-shadow: 0 0px 2px ${cssVar("grey")};
    border-bottom: 0.5px solid ${cssVar("grey-light")};
    // background-color: ${cssVar("blue-light")};
    // color: ${cssVar("blue-light")};
    /* background-color: ${cssVar("white")}; */
    background-color: ${cssVar("grey-lightest")};
    //background-color: ${cssVar("white")};
  `
);

/**
 * Overrides the default div props.
 */
export const Navbar = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const appCtx = useContext(AppContext);
  const { isMobileView } = appCtx;

  return (
    <StyledNavbar {...props}>
      <Spacer mt="5px">
        <Centered vertical gap="10px">
          <a href="/">
            <img src={LogoImg} alt="Logo" width="42px" height="42px" />
          </a>
          Nicholas Bucher
        </Centered>
      </Spacer>
      <div>
        {/* [is Mobile:{isMobileView ? "true" : "false"}]&nbsp;{props.children} */}
        {isMobileView ? (
          // <div>Mobile stuff</div>
          <>
            <div>
              <Link href="/">Home</Link>
              <Link href="/site/demo">UI Demo</Link>
              <LogInButton />
            </div>
          </>
        ) : (
          <Centered vertical gap="15px;">
            <Link hideMarkIfVisited href="/">
              Home
            </Link>
            <Link hideMarkIfVisited href="/site/demo">
              UI Demo
            </Link>
            {/* <Link hideMarkIfVisited href="/portfolio">
							Portfolio
						</Link>
						<Link hideMarkIfVisited href="/resume">
							Resume
						</Link> */}
            <LogInButton />
          </Centered>
        )}
      </div>
    </StyledNavbar>
  );
};
